export enum CustomFieldType {
  Text = 0,
  TextArea = 1,
  Checkbox = 2,
}

export enum CustomFieldValidationType {
  Custom = 0,
  Text = 1,
  Number = 2,
  Date = 3,
  Email = 4,
  Checkbox = 5,
}

type CustomFieldId = { LottoId: number; RewardItemId?: never } | { RewardItemId: number; LottoId?: never };

export type CustomField = {
  CustomFieldId: number;
  DisplayName: string;
  FieldType: CustomFieldType;
  CharacterLimit: number;
  ValidationRegEx: string;
  IsRequired: boolean;
  ValidationType: CustomFieldValidationType;
} & CustomFieldId;
